import { c as _c } from "react/compiler-runtime";
import { useMemo } from 'react';
import type { DoughnutSeries } from '@/modules/finances/types';
import { LegendItemMobile } from './legend-item-mobile';
interface MobileChartProps {
  seriesData: DoughnutSeries[];
}
function MobileChart(t0) {
  const $ = _c(18);
  const {
    seriesData
  } = t0;
  const total = seriesData.reduce(_temp, 0);
  let t1;
  if ($[0] !== seriesData || $[1] !== total) {
    let t2;
    if ($[3] !== total) {
      t2 = item_0 => ({
        ...item_0,
        percentage: item_0.value / total * 100
      });
      $[3] = total;
      $[4] = t2;
    } else {
      t2 = $[4];
    }
    t1 = seriesData.map(t2);
    $[0] = seriesData;
    $[1] = total;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const series = t1;
  let t2;
  if ($[5] !== series) {
    t2 = series.map(_temp2);
    $[5] = series;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  let t3;
  if ($[7] !== t2) {
    t3 = <div data-slot="chart-track" className="bg-accent flex min-h-48 w-8 min-w-8 flex-col self-stretch overflow-hidden rounded-lg">{t2}</div>;
    $[7] = t2;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  let t4;
  if ($[9] !== seriesData) {
    let t5;
    if ($[11] !== seriesData.length) {
      t5 = item_2 => <LegendItemMobile key={item_2.name} inline={seriesData.length > 4} name={item_2.name} code={item_2.code} color={item_2.color} value={item_2.value} percentage={item_2.percent} />;
      $[11] = seriesData.length;
      $[12] = t5;
    } else {
      t5 = $[12];
    }
    t4 = seriesData.map(t5);
    $[9] = seriesData;
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  let t5;
  if ($[13] !== t4) {
    t5 = <div data-slot="legends-wrapper" className="bg-accent flex min-h-48 w-full flex-col items-center justify-center rounded-xl p-4"><div data-slot="legend-list" className="flex flex-col gap-2">{t4}</div></div>;
    $[13] = t4;
    $[14] = t5;
  } else {
    t5 = $[14];
  }
  let t6;
  if ($[15] !== t3 || $[16] !== t5) {
    t6 = <div data-slot="mobile-chart" className="flex gap-4 px-4 pt-2 pb-4">{t3}{t5}</div>;
    $[15] = t3;
    $[16] = t5;
    $[17] = t6;
  } else {
    t6 = $[17];
  }
  return t6;
}
function _temp2(item_1, index) {
  return <div key={index} data-slot="chart-bar" className="w-full" style={{
    backgroundColor: item_1.color,
    height: `${isNaN(item_1.percentage) ? 0 : item_1.percentage}%`
  }} />;
}
function _temp(acc, item) {
  return acc + item.value;
}
export { MobileChart };